import { DriversType } from '@shared-features/enums/drivers-type.enum';
import { BusinessType } from '@shared-features/enums/business-type.enum';
import { UserInvoiceType } from '@shared-features/enums/user-invoice-type.enum';

export class AssignFleetPayload {
  shipmentId?: number;
  shipmentUuid?: string;
  fleetId: number;
  targetFleetId?: number;
  driverId: number;
  truckId?: number;
  assignType?: DriversType;
  startShipment?: boolean;
  sendToCustomer?: boolean;
  sendToReceiver?: boolean;
  customerMobileNumber?: string;
  receiverMobileNumber?: string;
  forceClose?: boolean;
  comment?: string;
  assignAndAutoStart?: boolean;
  customerPrice?: number;
  fleetPrice?: number;
  reassignComment?: string;
  businessType?: BusinessType;
  serviceType?:UserInvoiceType
}
